import { translate } from '@repo/phrase';
import { getAppLocale } from '@repo/utils';
import { isDefined } from '@repo/utils/type.utils';

import { getSymbolFromCurrency } from '@/lib/currency-symbol-map';

import { getAppConfig } from '@/utils/window.utils';

interface FormatPriceOptions {
    forceFixed?: boolean;
    includeCurrency?: boolean;
}

export const formatNumber = (value?: number, maximumFractionDigits = 3): string | undefined =>
    isDefined(value) ? new Intl.NumberFormat(getAppLocale(), { maximumFractionDigits }).format(value) : undefined;

export const formatPrice = (
    price?: number,
    currency?: string,
    { forceFixed = true, includeCurrency = true }: FormatPriceOptions = {}
): string | undefined => {
    if (!isDefined(price)) {
        return;
    }

    // Without a currency the value is rendered next to locale-formatted numbers
    // (quantities, weights), so it has to use the same separators.
    if (!includeCurrency) {
        return new Intl.NumberFormat(getAppLocale(), {
            minimumFractionDigits: forceFixed ? 2 : 0,
            maximumFractionDigits: 2,
        }).format(price);
    }

    if (!isDefined(currency)) {
        return;
    }

    const displayCurrency = getAppConfig().priceFormat.useCurrencySymbolMap
        ? (getSymbolFromCurrency(currency) ?? currency)
        : currency;

    return translate('price_currency_format', {
        price: forceFixed ? price.toFixed(2) : price.toFixed(2).replace(/\.00$/, ''),
        currency: displayCurrency,
    });
};

export const getServicePaymentTranslation = (servicePaymentTo: string | undefined, isOrder: boolean) => {
    // Not showing Service provider payment info in quotations since only the article price is promised.
    if (!isOrder) {
        return '';
    }
    switch (servicePaymentTo) {
        case 'PAY_TO_IKEA': {
            return translate('services_table_pay_ikea');
        }
        case 'PAY_TO_SP': {
            return translate('services_table_provider');
        }
        default: {
            return '';
        }
    }
};
